import { SelectOption } from "@veneer/core";

const metricSearchSelect = <T extends Record<string, SelectOption[]>>() => {
  async function handleSearch(
    value: string,
    key: keyof T,
    optionsCopy: SelectOption[],
    setOptions: (options: React.SetStateAction<T>) => void
  ) {
    try {
      const lowerCaseQuery = value.toLocaleLowerCase();
      const filteredOptions = optionsCopy.filter((objeto) =>
        objeto.label?.toLocaleLowerCase().includes(lowerCaseQuery)
      );
      setOptions((prevState) => ({
        ...prevState,
        [key]: filteredOptions,
      }));
    } catch (error) {
      console.error("Error during search: ", error);
    }
  }

  return {
    handleSearch,
  };
};

export default metricSearchSelect;